import { getNewsCategoryConfig } from './newsCategoryConfig'

export function CategoryFallbackArtwork({ category, storyId, priority = false }: { category?: string; storyId: string; priority?: boolean }) {
  const config = getNewsCategoryConfig(category)

  return <div className="news-fallback-art" aria-hidden="true" data-category-art={config.slug}>
    <img
      className="news-fallback-art__image"
      src={config.fallbackImage}
      alt=""
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      decoding="async"
      style={{ objectPosition: config.fallbackPosition }}
    />
    <span className="news-fallback-art__index">OMK / {storyId.slice(0, 6).toUpperCase()}</span>
    <span className="news-fallback-art__signal">{config.signal} · EDITORIAL FIELD</span>
  </div>
}
